import React, { useContext, useEffect } from "react";
import styled from "styled-components";
import Axios from "axios";

import { HOST } from "../../../Utils/constants";
import languagePack from "../../../Utils/language";
import useState from "../../../Hooks/useState";
import { ToFixed, numberWithCommas } from "../../../Utils/util";
import globalContext from "../../../Hooks/globalContext";
import PageWrapper from "../../../Components/Common/PageWrapper";
import GoBack from "../../../Components/Common/GoBack";

const ScrollView = styled.div`
  width: 100%;
  padding-bottom: 10px;
`;

const RowWrapper = styled.div`
  height: 75px;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 7.5px 15px;
  background-color: white;
  border-bottom: 1px solid ${(props) => props.theme.lightGrey};
`;

const InfoWrapper = styled.div`
  width: 100%;
`;

const ProductTitle = styled.div`
  font-size: 15px;
`;

const ProductPrice = styled.div`
  font-weight: bold;
  font-size: 13px;
`;

const OrderStatus = styled.div``;

const OrderDetail = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  margin-top: 5px;
`;

const Image = styled.img`
  width: 50px;
  height: 50px;
  border-radius: 25px;
  margin-right: 10px;
`;

const NoneTitleView = styled.div`
  padding: 20px;
`;

const NoneTitle = styled.div`
  text-align: center;
  color: ${(props) => props.theme.darkGrey};
  font-size: 15px;
`;

const Container = ({ history }) => {
  const { language, httpHeader } = useContext(globalContext);
  const disabled = useState(true);
  const isLoading = useState(false);
  const list = useState(null);

  const getInformation = async () => {
    const { data } = await Axios.post(`${HOST}/user/order/list`, null, httpHeader());
    list.setState(data);
  };

  const preload = () => {
    getInformation();
  };

  const goBackOnClick = () => {
    history.goBack();
  };

  useEffect(preload, []);

  const Row = ({ item }) => {
    if (item.available === 1 && item.status === 0) {
      disabled.setState(false);
    }
    return (
      <RowWrapper>
        <Image src={`${HOST}/${item.image}`} />
        <InfoWrapper>
          <ProductTitle>{item.title}</ProductTitle>
          <OrderDetail>
            <ProductPrice>
              {item.price_krw} ￦ ({numberWithCommas(ToFixed(item.amount))} LCMS)
            </ProductPrice>
            {item.status === 0 && (
              <OrderStatus style={{ color: "#4BA2F5" }}>{languagePack("주문 완료", language.state)}</OrderStatus>
            )}
            {item.status === 1 && (
              <OrderStatus style={{ color: "4BA2F5" }}>{languagePack("배송 준비", language.state)}</OrderStatus>
            )}
            {item.status === 2 && (
              <OrderStatus style={{ color: "green" }}>{languagePack("배송 중", language.state)}</OrderStatus>
            )}
            {item.status === 3 && (
              <OrderStatus style={{ color: "green" }}>{languagePack("배송 완료", language.state)}</OrderStatus>
            )}
          </OrderDetail>
        </InfoWrapper>
      </RowWrapper>
    );
  };

  return (
    <PageWrapper>
      <GoBack onClick={goBackOnClick} />
      <ScrollView>
        {list.state &&
          list.state.map((item, index) => {
            return <Row key={index} item={item} />;
          })}
        {list.state && list.state.length === 0 && (
          <NoneTitleView>
            <NoneTitle>{languagePack("기록이 없습니다.", language.state)}</NoneTitle>
          </NoneTitleView>
        )}
      </ScrollView>
    </PageWrapper>
  );
};

export default Container;
